export enum DrawerState {
  DEPUBLISH = 'DEPUBLISHED',
  REPUBLISH = 'REPUBLISH',
  PUBLISH = 'PUBLISH',
}

export enum DrawerStateBultTranscode {
  INTEGRATED = 'INTEGRATED',
  NONINTEGRATED = 'NONINTEGRATED',
}

export const initialApplicableAttribute = {
  selectedAttribute: null,
  selectedUpdateType: null,
  selectedValueType: null,
}

export const drawerConstant: any = {
  'bulk-update': {
    title: 'Create Update',
    showInput: true,
    field1Label: 'Job Name',
    field2Lable: 'Attribute',
    showDropdown: true,
    showSelectableBtn: false,
    showCheckbox: false,
    createBtnLabel: 'Create',
    showTips: false,
  },
  'bulk-state-change': {
    title: 'Create State Change',
    showInput: true,
    field1Label: 'Job Name',
    field2Lable: 'Target State',
    showDropdown: false,
    showSelectableBtn: true,
    isMultipleButton: false,
    showCheckbox: false,
    createBtnLabel: 'Create',
    showTips: false,
    selectableBtnList: [
      { value: 'De-Publish', key: DrawerState.DEPUBLISH },
      { value: 'Publish', key: DrawerState.PUBLISH },
      { value: 'Re-Publish', key: DrawerState.REPUBLISH },
    ],
  },
  'interactive-bulk-update': {
    title: 'Create Update',
    showInput: true,
    field1Label: 'Job Name',
    field3Label: 'Applicable Attributes',
    showDropdown: false,
    showSelectableBtn: false,
    showCheckbox: false,
    createBtnLabel: 'Create',
    showTips: false,
    showApplicableAttributes: true,
  },
  'manage-file': {
    title: 'Upload File',
    showInput: true,
    field1Label: 'Job Name',
    field2Lable: 'Choose File Type',
    showDropdown: false,
    showSelectableBtn: true,
    isMultipleButton: false,
    showCheckbox: false,
    createBtnLabel: 'Upload',
    showTips: false,
    selectableBtnList: [
      { value: 'Image', key: 'images' },
      { value: 'Subtitle', key: 'subtitle' },
    ],
  },
  'image-variant': {
    title: 'Create Language Image Variants',
    showInput: false,
    field1Label: '',
    field2Lable: 'Languages',
    showDropdown: false,
    showSelectableBtn: true,
    isMultipleButton: true,
    showCheckbox: true,
    selectableBtnList: [],
    createBtnLabel: 'Create',
    showTips: true,
  },
  'bulk-transcoding': {
    title: 'Create Update',
    showInput: true,
    field1Label: 'Job Name',
    field2Lable: 'File Type',
    showDropdown: false,
    showSelectableBtn: true,
    showCheckbox: false,
    createBtnLabel: 'Create',
    showTips: false,
    selectableBtnList: [
      { value: 'Integrated', key: DrawerStateBultTranscode.INTEGRATED },
      { value: 'Non-Integrated', key: DrawerStateBultTranscode.NONINTEGRATED, isDisable: true },
    ],
  },
}

export const getDrawerConfig = (key: string) => {
  for (const path in drawerConstant) {
    if (key.includes('bulk-operations')) {
      if (key.replace('/bulk-operations/', '') === path) return drawerConstant[path]
    } else if (key.includes(path)) {
      return drawerConstant[path]
    }
  }
  return {}
}

export const CONFIG = {
  EXPORT_POLLING_INTERVAL: 10000, // 10 seconds
  L_V_LANG_TYPE: 'AD_LANGUAGES' as const,
  ALLOWED_LANG_VARIANT_CATEGORY: ['CONTENT_MEDIA_IMAGE'],
  BULK_OPS_TYPES: {
    BULK_UPDATE: 'BULK_UPDATE',
    BULK_STATE_CHANGE: 'BULK_STATE_CHANGE',
    INTERACTIVE_BULK_UPDATE: 'INTERACTIVE_BULK_UPDATE',
    BULK_OPERATIONS_REPORTS: 'BULK_OPERATIONS_REPORTS',
    BULK_TRANSCODING: 'BULK_UPDATE_TRANSCODING',
  },
  BULK_STATE_CHANGE_TYPES: {
    PUBLISH: DrawerState.PUBLISH,
    REPUBLISH: DrawerState.REPUBLISH,
    DEPUBLISH: DrawerState.DEPUBLISH,
  },
  BSC_DISABLE_CHECKBOX: ['bulk-state-change'],
  BOOLEAN_OP_TYPES: [
    { label: 'Yes', value: 'Yes' },
    { label: 'No', value: 'No' },
  ],
  BULK_UPDATE_BEHAVIOUR: 'BULK_UPDATE_BEHAVIOUR',
  LISTING_LIMIT_OPTIONS: [
    { label: 10, value: 10 },
    { label: 20, value: 20 },
    { label: 50, value: 50 },
  ],
  LISTING_LIMIT_OPTIONS_HUNDRADE: [
    { label: 10, value: 10 },
    { label: 20, value: 20 },
    { label: 50, value: 50 },
    { label: 100, value: 100 },
  ],
  LA_COMPLEX_HIIDEN: ['adConfig', 'inputFeed'],
  ENCODED_FIELDS: ['inputFeed', 'feedLanguage', 'feedUrl', 'feedType'],
  SRT_FIELDS: ['srtMode', 'srtType', 'url', 'audioTracks', 'language', 'trackId', 'srtPlatform'],
}
export const LIVE_ASSET_GROUP_ATTRIBUTES = [
  'inputType',
  'adConfig',
  'inputFeed',
  'eventTier',
  'feedLanguage',
  'feedUrl',
  'feedType',
  'adConfigurations',
  'audioLanguageName',
  'adType',
  'platforms',
  'partnerName',
  'adDecisioningServer',
  'adTagUrl',
  'srtType',
  'url',
  'srtMode',
  'inputFeedInformation',
  'audioTracks',
  'language',
  'trackId',
  'eventTiming',
  'postSlateEnd',
  'telecastTime',
  'testingStartTime',
  'preSlate',
  'srtPlatform',
]
